export const basicBtnList = [
  { id: "COMPLETE", name: "完成" },
  { id: "UPDATE", name: "编辑" },
  { id: "REDO", name: "重启" },
  { id: "DELETE", name: "删除" },
  { id: "COPY", name: "复制" },
  { id: "CHANGE_GROUP", name: "移动" },
  { id: "UPDATE_PARENT_ID", name: "更改父任务" },
  { id: "MILESTONE", name: "标记为里程碑" },
  { id: "RISK", name: "标记为风险" },
  { id: "PRIVATE", name: "设为隐私模式" }
]
